export default {
    LIST_VENDOR: 'LIST_VENDOR',
    SELECT_VENDOR: 'SELECT_VENDOR',
    RETRIEVE_VENDOR: 'RETRIEVE_VENDOR',
    UPDATE_VENDOR: 'UPDATE_VENDOR',
    CREATE_VENDOR: 'CREATE_VENDOR'
};



/** WEBPACK FOOTER **
 ** ./src/constants/vendor.js
 **/